import React, { useState, useEffect } from "react";
import ToastItem from "./ToastItem";
import Style from "./Toast.module.css";

const Toast = (props) => {
  const { toastList, removeToast } = props;
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (toastList === null) {
      setShow(false);
      return;
    }
    if (toastList.hasOwnProperty("title")) {
      setShow(true);
      const intervalId = setTimeout(() => {
        setShow(false);
      },toastList.timeout || 2000);
      return () => clearTimeout(intervalId);
    }
  }, [toastList]);

  return show ? (
    <div className={`${Style.notificationContainer} ${Style.topRight}`}>
      <ToastItem toast={toastList} removeToast={removeToast} />
    </div>
  ) : (
    <></>
  );
};

Toast.defaultProps = {
  toastList: {},
};

export default Toast;
